module.exports = __webpack_public_path__ + "static/media/ServiceWHL.aea29701.jpg";